export const mainAggById = new Map();

export function getMainAgg(isLive, sportId) {
    return mainAggById.get(`${isLive ? 'lv' : 'pr'}_${sportId}`);
}
